// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".position-relative[data-v-f95d9498]{min-height:125px;position:relative}.none-wrapper[data-v-f95d9498]{left:50%;position:absolute;top:6vh;transform:translateX(-50%)}.empty-subcategory[data-v-f95d9498]{height:58px}.dots-vertical[data-v-f95d9498]{position:relative}.success--text[data-v-f95d9498] .v-input--selection-controls__input .v-icon{caret-color:#47c54f!important;color:#47c54f!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
